var _path, _path2, _path3, _path4, _path5, _path6, _path7, _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2668 454",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M757.214 195.628C769.341 200.217 780.187 206.474 788.947 214.43C797.707 222.772 804.828 232.814 810.251 244.076C815.256 255.339 817.759 267.883 817.759 281.679C817.759 295.474 815.256 307.571 810.251 318.864C804.828 330.127 797.707 340.168 788.947 348.094C780.187 356.437 769.311 362.724 757.214 367.312C744.67 371.901 731.321 374.404 716.692 374.404H570.841V77.875H792.284V135.5H631.803V188.954H716.692C731.292 188.954 744.67 191.04 757.214 195.628ZM747.173 254.118C739.247 247.86 728.789 244.523 715.857 244.523H631.803V318.447H715.857C728.789 318.447 739.247 315.11 747.173 308.853C755.099 302.596 758.853 293.806 758.853 281.709C758.883 269.552 755.099 260.375 747.173 254.118Z",
    fill: "#006DF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M930.835 374.404H872.494V77.875H930.835V203.584L1034.55 77.875H1107.08L988.758 220.299L1131.78 374.404H1055.62L930.835 239.905V374.404Z",
    fill: "#006DF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.34 367.281C1202.54 359.355 1186.24 348.48 1172.48 334.714C1158.68 320.918 1147.84 305.067 1139.91 286.266C1131.99 267.465 1128.2 247.412 1128.2 226.108C1128.2 204.804 1131.96 184.751 1139.91 165.95C1147.84 147.149 1158.71 130.88 1172.48 117.085C1186.24 103.289 1202.54 92.4436 1221.34 84.5179C1240.15 76.5922 1261.03 72.8379 1283.59 72.8379C1300.3 72.8379 1316.57 75.3408 1332.04 80.3465C1347.5 85.7694 1361.68 92.8905 1374.64 102.068C1387.19 111.662 1398.03 122.537 1407.21 135.469C1416.39 148.43 1423.09 163.03 1427.26 178.911H1361.68C1358.76 171.403 1354.59 164.699 1349.14 158.859C1343.72 153.019 1337.43 148.013 1330.34 143.812C1323.25 140.057 1316.12 136.72 1308.2 134.635C1300.27 132.549 1291.9 131.297 1283.56 131.297C1269.35 131.297 1256.41 133.8 1245.12 138.389C1233.44 143.395 1223.4 150.069 1215.06 158.859C1206.71 167.619 1200.43 177.66 1195.84 188.923C1191.25 200.186 1189.16 212.73 1189.16 226.108C1189.16 239.486 1191.25 252.001 1195.84 263.293C1200.43 274.556 1206.68 284.597 1215.06 293.357C1223.4 302.117 1233.44 308.821 1245.12 313.41C1256.38 318.416 1269.35 320.918 1283.56 320.918C1291.9 320.918 1300.27 319.667 1308.2 317.581C1316.12 315.496 1323.25 312.158 1330.34 307.987C1337.43 304.233 1343.72 299.227 1349.14 293.357C1354.56 287.517 1358.73 280.813 1361.68 273.305H1427.26C1423.09 289.186 1416.42 303.369 1407.21 316.33C1398 329.291 1387.16 340.554 1374.64 349.731C1361.71 359.325 1347.5 366.446 1332.04 371.452C1316.57 376.875 1300.3 379.378 1283.59 379.378C1261.03 379.408 1240.15 375.236 1221.34 367.281Z",
    fill: "#006DF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1592.95 205.185V109.668H1734.78V79.8965H1561.52V373.476H1663.66C1720.72 373.476 1762.48 344.532 1762.48 289.537C1762.48 233.716 1720.72 205.185 1663.66 205.185H1592.95ZM1730.64 289.537C1730.64 324.271 1707.07 344.118 1664.07 344.118H1592.95V234.543H1664.07C1707.07 234.543 1730.64 254.39 1730.64 289.537Z",
    fill: "#006DF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1777.89 373.476H1810.14L1850.66 282.095H1990.83L2031.77 373.476H2064.85L1933.77 79.8965H1908.55L1777.89 373.476ZM1920.54 124.14L1978.02 252.737H1863.48L1920.54 124.14Z",
    fill: "#006DF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2109.08 373.476H2140.5V237.437H2312.1V373.476H2343.53V79.8965H2312.1V207.666H2140.5V79.8965H2109.08V373.476Z",
    fill: "#006DF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2621.25 373.476H2667.97L2488.1 219.244L2634.07 79.8965H2591.48L2456.27 208.493V79.8965H2425.25V373.476H2456.27V231.648L2621.25 373.476Z",
    fill: "#006DF0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 454,
    height: 454
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 226.754,
    cy: 226.754,
    r: 226.754,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.666 24.1398C450.955 88.0736 492.011 229.894 429.356 340.923C366.702 451.951 224.079 490.092 110.789 426.158C-2.50056 362.224 -43.5561 220.404 19.0982 109.375C81.7526 -1.65385 224.376 -39.7939 337.666 24.1398Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.666 24.1398C450.955 88.0736 492.011 229.894 429.356 340.923C366.702 451.951 224.079 490.092 110.789 426.158C-2.50056 362.224 -43.5561 220.404 19.0982 109.375C81.7526 -1.65385 224.376 -39.7939 337.666 24.1398Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.158 314.654C35.6551 230.847 27.4737 107.293 102.861 38.7178C178.249 -29.8572 308.674 -17.5108 394.177 66.2965C479.68 150.104 487.861 273.628 412.444 342.233C337.026 410.838 206.631 398.461 121.158 314.654Z",
    fill: "url(#paint2_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.077 227.28C124.125 177.499 82.5711 93.0484 118.252 38.7058C153.934 -15.6368 253.376 -19.363 340.328 30.4187C427.281 80.2005 468.834 164.651 433.123 219.023C397.412 273.395 298.03 277.092 211.077 227.28Z",
    fill: "url(#paint3_radial)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 216.889,
    y1: 457.132,
    x2: 224.582,
    y2: 26.0217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4581E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#80ACF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 587.65,
    y1: 452.849,
    x2: 193.467,
    y2: 99.5341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4581E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4581E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.68 252.714) rotate(-156.356) scale(543.832 1121.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0969745,
    stopColor: "#4581E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459935,
    stopColor: "#80ACF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794216,
    stopColor: "#F0F6FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(690.149 41.5276) rotate(176.049) scale(478.375 573.804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4581E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536835,
    stopColor: "#87B1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805657,
    stopColor: "#CCE0FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F6FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.2143b2c3292ca3c0936e805e4ef440f3.svg";
export { ForwardRef as ReactComponent };